import React from 'react';
import RequireEvent from '../../components/RequireEvent';
import '../../styles/guests.css';
import { choose } from '../../utils/platform';
import { useMembers } from './useMembers';
import MembersDesktop from './Members.desktop';
import MembersMobile from './Members.mobile';

const MembersView = choose(MembersDesktop, MembersMobile);

function MembersInner({ event }) {
  const vm = useMembers(event);
  if (!vm.canView) {
    return (
      <div>
        <div className="page-head"><h1>Guests</h1></div>
        <div className="card card-pad empty">You don't have access to guests. Ask an Event Admin to grant it.</div>
      </div>
    );
  }
  return <MembersView vm={vm} />;
}

// Hooks must run unconditionally, so the access check lives inside MembersInner.
export default function Members() {
  return <RequireEvent>{(event) => <MembersInner event={event} />}</RequireEvent>;
}
